import * as React from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";

export interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const DetailItemText: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { children } = props;
  return <div css={textBlockStyle}>{children}</div>;
};

const textBlockStyle = css`
  padding: 0 ${space.atom};
`;
